export const API_BASE_URL=process.env.REACT_APP_API_URL || 'http://localhost:3000/api'; 

export const GA_MEASUREMENT_ID = 'G-JGE7LHVE6K'; // 替换为你的 GA4 测量 ID 